import actions from "@/store/modules/guest-schedule/actions";
import mutations from "@/store/modules/guest-schedule/mutations";
import state from "@/store/modules/guest-schedule/state";

export default {
    actions,
    mutations,
    state
}